function TemplatePointers() {
    return (
        <>
            <h1 className="text-2xl mt-8 font-bold">Welcome to Nation9 First</h1>
        
        </>
    )
}

export default TemplatePointers;
